import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getValidToken, hasAuthSession } from "../utils/tokenUtils";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const hasSession = hasAuthSession() || Boolean(getValidToken());

    if (isLoggedIn) {
      setIsChecking(false);
    } else if (hasSession) {
      const timer = setTimeout(() => {
        setIsChecking(false);
      }, 150);
      return () => clearTimeout(timer);
    } else {
      setIsChecking(false);
    }
  }, [isLoggedIn]);

  if (isChecking) {
    return null;
  }

  if (!isLoggedIn && !hasAuthSession()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
